import { Autocomplete, CircularProgress, TextField } from "@mui/material";
import { searchUserApi } from "API/apis/search/searchUsers";
import { message } from "constants/responses/message";
import React, { useState } from "react";

export const SearchUsers = ({
  label,
  selectedUser,
  handleUserSelection,
  isRequired = false,
  deptFilter,
}) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);

  const handleChange = async (newValue) => {
    if (newValue.length < 3) {
      return;
    }
    setLoading(true);
    const { data, status } = await searchUserApi(newValue, deptFilter);
    if (status !== 200) {
      throw new Error(message.error.generalFailure);
    }
    setOptions(data);
    setLoading(false);
  };
  return (
    <Autocomplete
      disablePortal
      options={options}
      onChange={(event, newValue) => {
        handleUserSelection(newValue);
      }}
      value={selectedUser}
      getOptionKey={(option) => option.userId}
      getOptionLabel={(option) =>
        option?.name ? `${option.name} | ${option.subDept}` : ``
      }
      onInputChange={(e, newValue) => handleChange(newValue)}
      renderInput={(params) => (
        <TextField
          required={isRequired}
          {...params}
          label={label}
          slotProps={{
            input: {
              ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {loading ? (
                    <CircularProgress color="inherit" size={20} />
                  ) : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            },
          }}
        />
      )}
    />
  );
};
